import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InputBar from "components/InputBar/InputBar";
import useCart from "hooks/useCart";
import { OfferIcon } from "constants/icons";
import { requestPostFetchApi } from "utils/apiMethods";
import { API_KEYS } from "constants/apiEndpoints";
import { pushCouponCodeToCart } from "store/actions/cart.action";
import { classNameConditional } from "utils/commonMethods";
import "containers/CartOverview/CouponInputBox/CouponInputBox.css";

//Renders input component for coupon code.
function CouponInputBox({ id, showErrorToast }) {
  const componentTexts = window.appTexts.components.coupon_input_box;
  const cartCouponDetails = useSelector(
    (state) => state.cartReducer.couponDetails
  );
  const { currentCartItems } = useCart();
  const dispatch = useDispatch();
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);
  //State management.
  const [couponCode, setCouponCode] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    setCouponCode(cartCouponDetails ? cartCouponDetails.couponCode : "");
    setCouponMessage(cartCouponDetails?.coMsg);
  }, [cartCouponDetails]);

  //Controllers.
  const onCouponChange = function (name, code) {
    return setCouponCode(code);
  };

  const onSubmitHandler = function () {
    //Validation check for coupon.
    if (couponCode.length < 3) {
      return showErrorToast(
        componentTexts.error_min_digits_title,
        componentTexts.error_min_digits_desc
      );
    }
    setShowLoader(true);
    setCouponMessage("");
    //Apply coupon to the cart.
    requestPostFetchApi(API_KEYS.APPLY_COUPON, {
      cUid: id,
      coCode: couponCode,
      id: vendingMachineDetails.id,
      items: currentCartItems.map((ele) => ({
        iUID: ele.item.iUID,
        sid: ele.item.sid,
        iQty: ele.quantity,
      })),
      time: new Date().getTime(),
    }).then(
      (response) => {
        //Set coupon to the redux.
        setCouponMessage(response.data.coMsg);
        if (response.data.coState === 0) {
          dispatch(pushCouponCodeToCart({ ...response.data, couponCode }));
        }
        setShowLoader(false);
      },
      () => {
        setShowLoader(false);
      }
    );
  };

  const removeCouponCode = function () {
    setCouponCode("");
    setCouponMessage("");
    dispatch(pushCouponCodeToCart(null));
  };

  return (
    <div
      className={
        "coupon-input-box__wrapper " +
        classNameConditional(cartCouponDetails, "coupon-input-box__highlight")
      }
    >
      <InputBar
        value={couponCode}
        className="coupon-input-box outer-shadow"
        onChange={onCouponChange}
        PlaceholderIcon={OfferIcon}
        inputProps={{
          placeholder: componentTexts.placeholder,
          disabled: cartCouponDetails,
        }}
      >
        <div className="coupon-input-box__action">
          {cartCouponDetails ? (
            <span onClick={removeCouponCode}>
              {componentTexts.button_remove}
            </span>
          ) : (
            <span onClick={onSubmitHandler} className="cursor--pointer">
              {showLoader ? (
                <div className="loading-dots"></div>
              ) : (
                componentTexts.button_apply
              )}
            </span>
          )}
        </div>
      </InputBar>
      <p
        className={`coupon-input-box__status ${
          cartCouponDetails
            ? "coupon-applied--success"
            : "coupon-applied--failure"
        }`}
      >
        {couponMessage}
      </p>
    </div>
  );
}

export default CouponInputBox;
